import { ButtonVariant } from '@components/ui/Button/Button'

export const umbracoButtonMap = (input: string): ButtonVariant => {
  let buttonVariant: ButtonVariant = 'secondary-white'
  switch (input) {
    case 'solid black':
      buttonVariant = 'primary'
      break
    case 'solid white':
      buttonVariant = 'primary-white'
      break
    case 'ghost black':
      buttonVariant = 'secondary'
      break
    case 'ghost white':
      buttonVariant = 'secondary-white'
      break
    case 'link black':
      buttonVariant = 'link'
      break
    case 'link white':
      buttonVariant = 'link-white'
      break
    default:
      break
  }
  return buttonVariant
}
